<template>
  <asi-product-view v-if="supplierCode === 'asi'" />
  <sage-product-view v-else-if="supplierCode === 'sage'" />
  <product-view
    v-else
    :key="`${supplierCode}-${productId}`"
    :slug="slug"
    :product-id="productId"
    :supplier-code="supplierCode"
  />
</template>
<script>
export default {
  components: {
    ProductView: () => import('./ProductView'),
    SageProductView: () => import('./SageProductView'),
    AsiProductView: () => import('./AsiProductView')
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    productId() {
      return this.$route.params.productId;
    },
    supplierCode() {
      return this.$route.params.supplierCode;
    }
  }
};
</script>
